import React from 'react'
import Navbar from '../inc/Navbar'
import About from './About'
import {Link} from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
function Aboutpage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
       <div className='ackrishnagar'>
        <div className="album py-1 ">

          <div className="container mt-2">

            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">About Us</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <br/>
               <ScrollToTop Smooth top="100" color="#48340A" />
        <About/>
    </div>
  )
}

export default Aboutpage